module.exports = __webpack_public_path__ + "static/img/DANONE_LOGO.2c5ecd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DANONE_LOGO.png
// module id = N7Pt
// module chunks = 1